import React, { useEffect, useState } from "react";

import { DealRedirect } from "constants/deal";
import { useNavigate } from "hooks";
import { useAccountSelector, useDealUserRoleSelect, useViewActions } from "store";

import { RoleName } from "../../constants";

type Props = {
  children: React.ReactNode;
  availableRoles: RoleName[];
  forceRunRedirect?: boolean; //parameter need only for hide something if admin added restrictions for "user" permissions
  redirectInsideDeal?: DealRedirect;
  redirect?: () => void;
};

export const DealRouteRoleGuard: React.FC<Props> = ({
  children,
  availableRoles,
  redirectInsideDeal,
  forceRunRedirect,
  redirect
}) => {
  const { allow_news: isDashboardEnabled } = useAccountSelector() || {};
  const userRole = useDealUserRoleSelect();
  const { setDealRedirectAction } = useViewActions();
  const navigate = useNavigate();
  const isDashboardAvailable =
    isDashboardEnabled &&
    (userRole === RoleName.Admin || userRole === RoleName.Analyst || userRole === RoleName.TeamViewer);

  const [isContentAvailable, setIsContentAvailable] = useState<boolean>(false);

  const runRedirect = () => {
    if (redirectInsideDeal) {
      setDealRedirectAction(redirectInsideDeal);
    }

    if (redirect) {
      redirect();
    }

    if (!redirectInsideDeal && !redirect && isDashboardAvailable) {
      navigate({ route: "dashboard" });
      return;
    }

    if (!redirectInsideDeal && !redirect) {
      navigate({ route: "myDeals" });
    }
  };

  useEffect(() => {
    if (!userRole) {
      // return runRedirect();
      return setIsContentAvailable(true);
    }
    if (forceRunRedirect) {
      return runRedirect();
    }
    if (!availableRoles.some((item) => item === userRole)) {
      return runRedirect();
    }

    setIsContentAvailable(true);
  }, [userRole, availableRoles, forceRunRedirect]);

  if (!isContentAvailable) return <></>;

  return children;
};
